export enum AccommodationDocumentType {
  Sqm = "Sqm",
  GeneralRoutines = "GeneralRoutines",
  Other = "Other"
}
